import { releaseUnifiedFormSubmit } from '@gonfalon/dogfood-flags/dogfood-flags';

import type { MarketoForm } from './forms';

/**
 * Whether a form submits through the backend endpoint instead of the Marketo
 * client script.
 *
 * `release-unified-form-submit` is a map of form ID to boolean so forms can be
 * cut over one at a time and rolled back individually.
 */
export function isUnifiedFormSubmitEnabled(formId: MarketoForm): boolean {
  return !!releaseUnifiedFormSubmit()?.[formId];
}
